/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-suv-d95481e1--sprite",
  "use": "car-suv-d95481e1--sprite-usage",
  "viewBox": "0 0 49 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 49 24\" id=\"car-suv-d95481e1--sprite\"><path d=\"M2 9l.91 9.1a1 1 0 00.995.9H6M2 9h11M2 9l2.28-7.298A1 1 0 015.236 1H14m0 0l-1 8m1-8h9.5M36 9h7a5 5 0 015 5v4a1 1 0 01-1 1h-5M36 9l-7.707-7.707A1 1 0 0027.586 1H23.5M36 9H23.5M42 19a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H14m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m7-10h10.5m0 0V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M23.5 9H13l3 7h7.5m0-7H36l-4 7h-8.5m0-7v7M2 11h3v2H2.5M48 12h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
